//
//
//
//
//
//
//
//
//

import RbHeaderBaseProductSlide from '@/elements/header/product-slide/base-product-slide.vue'
import { LIGHT_GRAY, WHITE } from '@/scripts/constants/colours'
import { Akamai } from '@/scripts/libs/akamai'
import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-header-product-slide-with-params',
  extends: RbHeaderBaseProductSlide,
  props: {
    withGrayBackground: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
    imageWithParams() {
      const imageColor = this.withGrayBackground && !this.isMobile ? LIGHT_GRAY : WHITE

      return Akamai.addParams({ image: this.image, width: 152, color: imageColor })
    },
  },
}
